<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color} stroke-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 23 20">
    <path
      d="M12.72 10.8214C14.023 9.81319 14.8666 8.2522 14.8666 6.49673C14.864 3.46688 12.3618 1 9.28869 1C6.21554 1 3.71342 3.46688 3.71342 6.49673C3.71342 8.25476 4.55957 9.82087 5.86773 10.8266C2.82833 12.1496 0.777832 15.1641 0.777832 18.4882C0.777832 18.7697 1.01143 19 1.29694 19C1.58246 19 1.81606 18.7697 1.81606 18.4882C1.81606 15.3227 3.93663 12.472 6.98642 11.497C7.68982 11.8118 8.46589 11.9935 9.28869 11.9935C10.1115 11.9935 10.8927 11.8118 11.5987 11.4919C14.6433 12.4541 16.7613 15.3074 16.7613 18.4856C16.7613 18.7671 16.9949 18.9974 17.2804 18.9974C17.5659 18.9974 17.7995 18.7671 17.7995 18.4856C17.7995 15.1538 15.7516 12.1342 12.7174 10.8189L12.72 10.8214ZM9.28869 10.9699C6.78656 10.9699 4.75164 8.96361 4.75164 6.49673C4.75164 4.02986 6.78656 2.0236 9.28869 2.0236C11.7908 2.0236 13.8257 4.02986 13.8257 6.49673C13.8257 8.96361 11.7908 10.9699 9.28869 10.9699Z"
      :class="colorClass"
      stroke-width="0.3"
    />
    <path
      d="M22.7633 9.91803L19.9722 12.5884L19.5969 12.206L21.692 10.2016L21.71 10.1844H21.6851H15.6604V9.65166H21.6851H21.71L21.692 9.63444L19.5969 7.63006L19.9722 7.24769L22.7633 9.91803Z"
      :class="colorClass"
      stroke-width="0.02"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
